import React from "react";
import styled from "styled-components";
import {LANGUAGE_PATH} from "modules";
import {useTranslation} from "react-i18next";
import preregAlert from "apps/DRAW_PREDICTOR/assets/images/icons/preregAlert.svg";

const Overlay = styled.div`
	z-index: 1;
	position: absolute;
	top: 0;
	left: 50%;
	right: 50%;
	width: 100vw;
	height: 100%;
	margin-left: -50vw;
	margin-right: -50vw;
	background: rgb(152, 19, 59);
	background: linear-gradient(
		180deg,
		rgba(152, 19, 59, 0) 0%,
		rgba(164, 17, 61, 0.8) 2%,
		rgba(199, 12, 68, 0.8) 98%,
		rgba(210, 10, 70, 0) 100%
	);
`;

const ComingSoon = styled.div`
	max-width: 700px;
	margin: auto;
	padding: 0 20px;
	text-align: center;
	color: #fff;

	img {
		margin-bottom: 32px;
	}

	h6 {
		font-size: 25px;
		line-height: 30px;
		font-weight: 700;
		margin-bottom: 16px;
	}

	p {
		font-size: 20px;
		line-height: 32px;
	}
`;

export const PreDrawComingSoon: React.FC = () => {
	const {t} = useTranslation(LANGUAGE_PATH);

	return (
		<Overlay>
			<ComingSoon>
				<img src={preregAlert} alt={t("landing.tip.coming_soon")} />
				<h6>{t("landing.tip.coming_soon")}</h6>
				<p>{t("landing.tip.copy")}</p>
			</ComingSoon>
		</Overlay>
	);
};
